export const getLogoUrl = (text: string, theme: string) => {
    const logoUrl = new URL(`https://yastatic.net/q/logoaas/v2/${encodeURIComponent(text)}.svg`);

    logoUrl.searchParams.set('color', theme === 'dark' ? 'c0c0c2' : '000000');
    logoUrl.searchParams.set('size', '30');

    return logoUrl.toString();
};
